import * as RadixAccordion from '@radix-ui/react-accordion';
import { ChevronDownIcon } from '@radix-ui/react-icons';
import classNames from 'classnames';
import { forwardRef, useState } from 'react';

export const SingleAccordionItem = ({
  item,
  name,
  iconClassName,
  iconSize,
  children,
}: {
  item: string;
  name?: string;
  iconClassName?: string;
  iconSize?: number;
  children?: React.ReactNode;
}) => {
  const [isOverflowHidden, setIsOverflowHidden] = useState(false);

  return (
    <RadixAccordion.Item
      style={{ overflow: isOverflowHidden ? 'hidden' : 'visible' }}
      className="SingleAccordionItem"
      value={item}
    >
      <AccordionTrigger iconClassName={iconClassName} iconSize={iconSize}>
        <span>{name || item}</span>
      </AccordionTrigger>
      <AccordionContent>
        <div
          onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}
        >
          {children}
        </div>
      </AccordionContent>
    </RadixAccordion.Item>
  );
};

const AccordionTrigger = forwardRef<
  HTMLButtonElement,
  {
    children: React.ReactNode;
    className?: string;
    iconClassName?: string;
    iconSize?: number;
  }
>(
  (
    { children, className, iconClassName, iconSize, ...props },
    forwardedRef
  ) => (
    <RadixAccordion.Header className="SingleAccordionHeader">
      <RadixAccordion.Trigger
        className={classNames('SingleAccordionTrigger', className)}
        {...props}
        ref={forwardedRef}
      >
        <div className="SingleAccordionTriggerText">
          {iconClassName && (
            <i className={iconClassName} style={{ fontSize: iconSize }} />
          )}
          {children}
        </div>
        <ChevronDownIcon className="SingleAccordionChevron" aria-hidden />
      </RadixAccordion.Trigger>
    </RadixAccordion.Header>
  )
);

const AccordionContent = forwardRef<
  HTMLDivElement,
  { children: React.ReactNode; className?: string }
>(({ children, className, ...props }, forwardedRef) => (
  <RadixAccordion.Content
    className={classNames('SingleAccordionContent', className)}
    {...props}
    ref={forwardedRef}
  >
    <div className="SingleAccordionContentText">{children}</div>
  </RadixAccordion.Content>
));
